import { FC } from 'react';

import { Typography } from '../../../designComponents';

interface TaskDetailsPropsType {
  tags: {
    label: string;
    Role: string;
    desc: string;
  }[];
}
const TaskDetailsCard: FC<TaskDetailsPropsType> = ({ tags }) => {
  return (
    <>
      {tags.map((item, idx) => (
        <div className="details" key={idx}>
          <Typography fontColor="secondary">
            {idx + 1}.{''} {item.label}
          </Typography>
          <div className="desc">
            <Typography>Assigned Role : {item.Role}</Typography>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography>Description :</Typography>
              <Typography>{item.desc}</Typography>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default TaskDetailsCard;
